import { useTranslation } from 'react-i18next';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useEffect, useState } from 'react';
import { Doughnut, Pie } from 'react-chartjs-2';
import _ from 'lodash';
import 'styles/global.css';
import paiPalette from 'assets/js/palette';

ChartJS.register(ArcElement, Tooltip, Legend);

interface PieChartProps {
  chartData: any;
  /** Draw the ring (donut) form instead of the filled pie. */
  donut?: boolean;
}

export const PieChart = ({ chartData, donut = false }: PieChartProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    const optionsData = {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      plugins: {
        legend: {
          position: 'bottom',
          display: true,
        },
      },
    };

    setOptions(optionsData);
  }, []);

  const manuplateData = (chartData: any) => {
    if (chartData) {
      const pieChartTempData: any = {
        labels: [],
        datasets: [],
      };

      _.map(chartData, function (k) {
        const pieChartTempDataSet: any = {
          label: '',
          data: [],
          dataSymbol: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 1,
        };
        const colors = paiPalette('cb-Custom1', k['plots'].length).map(function (hex: any) {
          return '#' + hex;
        });

        const plots = k['plots'];
        const lables = [];

        for (let i = 0; i < plots.length; i++) {
          lables.push(plots[i]['name']);
          pieChartTempDataSet.data.push(plots[i]['value']);
          pieChartTempDataSet.dataSymbol.push([plots[i]['symbol'], 'Unit']);
          pieChartTempDataSet.backgroundColor.push(plots[i]['color'] || colors[i]);
          pieChartTempDataSet.borderColor.push(plots[i]['color'] || '#AAA');
        }
        pieChartTempData.labels = lables;
        pieChartTempData.datasets.push(pieChartTempDataSet);
      });

      return pieChartTempData;
    }
  };

  const data = manuplateData(chartData);

  if (data) {
    return (
      <div className="custom-chart-size">
        {donut ? <Doughnut data={data} options={options} /> : <Pie data={data} options={options} />}
      </div>
    );
  }

  return (
    <>
      <div className="">
        <img className="empty-state-3" src="/icons/Empty_icon.svg" alt="empty visual" />
      </div>
      <div className="">
        <label className="label-style-4 mt-3">{t('EMPTY_STATE.NO_DATA_FOUND')}</label>
      </div>
      <div className="w-50">
        <label className="label-style-5 mt-3">
          Please add the data to view corresponding visualisation here
        </label>
      </div>
    </>
  );
};
